
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TimeFrameItemProps } from ".";
import { loading, update } from "store/time-frame";
import { AppMessage } from "components";

interface ApiTimeFrameUpdateInputProps extends TimeFrameItemProps {
}

type ApiTimeFrameUpdateOutputProps = OutputBaseProps<{ item: TimeFrameItemProps; }, ApiTimeFrameUpdateInputProps>

export const apiTimeFrameUpdate = async (data: ApiTimeFrameUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiTimeFrameUpdateOutputProps>("/api/time-frame/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};